var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _rect;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotAssigned(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1679.59 1242.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f5cc00;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #e9e1ff;\n      }\n\n      .cls-4 {\n        fill: #7252b7;\n      }\n\n      .cls-5 {\n        fill: #2c2cbf;\n      }\n\n      .cls-6 {\n        fill: #bfa564;\n      }\n\n      .cls-7 {\n        fill: #3dacd8;\n      }\n\n      .cls-8 {\n        fill: #aed9e5;\n      }\n\n      .cls-9 {\n        opacity: .2;\n      }\n\n      .cls-10 {\n        fill: #8aaebc;\n      }\n\n      .cls-11 {\n        fill: #ff9498;\n        opacity: .4;\n      }\n\n      .cls-12 {\n        fill: #c0e8fc;\n      }\n\n      .cls-13 {\n        fill: #ffba9a;\n      }\n\n      .cls-14 {\n        fill: #cceaf2;\n      }\n\n      .cls-15 {\n        fill: #36295b;\n      }\n\n      .cls-16 {\n        fill: #c0efff;\n      }\n\n      .cls-17 {\n        fill: #bf643a;\n      }\n\n      .cls-18 {\n        fill: #4dd0ff;\n      }\n\n      .cls-19 {\n        fill: #008dc0;\n      }\n\n      .cls-20 {\n        fill: #00b3f3;\n      }\n\n      .cls-21 {\n        fill: #013d55;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m505.4,1095.76c-131.66-26.49-261.96-119.57-278-274.68-6.51-63.01,4.42-132.01,45.85-176.87,48.47-52.48,125.86-59.16,193.75-46.4,67.89,12.76,133.03,41.52,201.63,48.39,166.47,16.67,320.98-96.27,487.6-109.61,82.71-6.62,175.4,17.95,221.52,92.37,41.59,67.11,33.66,159.79-4.4,228.96-38.07,69.17-101.4,118.04-167.63,155.22-121.35,68.12-256.43,102.33-393.02,107.9-104.68,4.27-206.13-4.93-307.3-25.28Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "1416.5 847.25 1375.3 775.9 1457.69 775.9 1416.5 847.25"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m1324.84,758.12c0,17.68,14.33,32.02,32.02,32.02h290.7c17.67,0,32.02-14.35,32.02-32.02v-175.9h-354.75v175.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m1647.56,511.39h-290.7c-17.7,0-32.02,14.32-32.02,32.02v38.8h354.75v-38.8c0-17.7-14.35-32.02-32.02-32.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m1624.2,565.03c-10.05,0-18.22-8.17-18.22-18.22s8.17-18.22,18.22-18.22,18.22,8.18,18.22,18.22-8.17,18.22-18.22,18.22Zm0-32.7c-7.98,0-14.47,6.49-14.47,14.47s6.49,14.47,14.47,14.47,14.47-6.49,14.47-14.47-6.49-14.47-14.47-14.47Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1459.79,
    y: 616.61,
    width: 51.96,
    height: 13.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1459.79,
    y: 642.83,
    width: 76.82,
    height: 13.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1459.79,
    y: 669.05,
    width: 185.48,
    height: 13.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1459.79,
    y: 695.27,
    width: 109.73,
    height: 13.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1583.27,
    y: 721.49,
    width: 51.96,
    height: 13.83
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 1359.17,
    y: 607.22,
    width: 61.88,
    height: 39.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 1359.17,
    y: 664.72,
    width: 61.88,
    height: 69.71
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m749.8,234.99l-2.4-1.8c12.88-17.16,21.88-37.36,26.03-58.41.18-.92.35-1.87.51-2.82-6.33-3.24-9.42-9.56-10.14-14.65-.68-4.81.55-8.85,3.15-10.29,1.16-.65,3.62-1.3,7.01,1.55,4.62,3.89,4.39,13.73,3.3,21.56.56.2,1.15.36,1.77.51,6.36,1.45,13.24.06,19.38-3.93,6.75-4.38,11.64-11.4,13.09-18.78.46-2.32.62-4.7.52-7.08-7.74-.11-15.43-1.98-21.01-3.74-7.63-2.41-20.2-12.57-21.25-21.13-.73-5.92,1.75-8.88,3.96-10.32,5.45-3.56,14.84-1.65,20.91,1.95,11.11,6.6,18.61,18.29,20.13,30.21,7.19-.33,14.08-2.53,18.71-8.32,4.67-5.84,5.99-14.37,3.93-25.41-2.69-.13-5.39-.48-8.03-1.02-23.75-4.85-45.75-17.46-61.93-35.51-4.09-4.56-16.86-20.53-9.37-34.46,5.41-10.06,18.46-12.46,27.98-9.61,10.68,3.19,18.55,11.51,24.22,18.4,13.2,16.04,23.08,35.11,28.58,55.14.38,1.39.72,2.75,1.02,4.09h.09c10.47,0,21.8-3.26,24.69-13.3,2.44-8.49-2.87-17.39-7.77-24.2-17.59-24.43-40.53-45.54-66.35-61.04l1.55-2.57c26.16,15.71,49.41,37.1,67.24,61.86,5.3,7.36,11.02,17.05,8.22,26.78-3.06,10.63-14.61,15.39-27.06,15.51,2.05,11.65.5,20.78-4.65,27.22-5.24,6.56-12.91,9.04-20.8,9.42.11,2.6-.07,5.18-.57,7.71-1.6,8.15-6.98,15.9-14.4,20.71-6.83,4.43-14.53,5.98-21.69,4.34-.54-.12-1.06-.27-1.57-.43-.14.78-.27,1.53-.41,2.23-4.24,21.49-13.42,42.11-26.57,59.63Zm19.34-85.53c-.26,0-.52.05-.75.19-1.23.68-2.18,3.39-1.63,7.25.6,4.25,2.93,9.11,7.63,11.91.95-7.75.7-15.36-2.37-17.94-.69-.58-1.85-1.41-2.87-1.41Zm11.9-42.69c-2.2,0-4.2.42-5.69,1.4-2.17,1.42-3.05,3.92-2.62,7.44.85,6.97,12.55,16.55,19.17,18.64,5.28,1.67,12.56,3.46,19.83,3.61-1.49-10.91-8.42-21.6-18.65-27.67-3.39-2.01-8.04-3.41-12.04-3.41Zm-2.72-81.37c-7.01,0-14.27,2.89-17.63,9.13-6.56,12.2,5.2,26.84,8.96,31.03,15.76,17.57,37.18,29.85,60.3,34.57,2.08.42,4.39.74,6.79.89-.24-1.04-.51-2.11-.81-3.19-5.39-19.63-15.07-38.31-28.01-54.03-5.4-6.56-12.86-14.47-22.76-17.43-2.15-.64-4.49-.97-6.85-.97Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m442.12,381.38c5.83-.11,11.65-.04,17.47-.03,5.82-.01,11.64.11,17.46.2,11.64.22,23.27.58,34.89,1l4.93.18-1.89,4.85-7.83,20.04-8,19.97-2.62-5.01c10.81,2.07,21.61,4.21,32.38,6.48,5.38,1.17,10.77,2.29,16.14,3.55,5.37,1.24,10.75,2.43,16.1,3.79l-.47,2.89c-5.48-.58-10.93-1.34-16.39-2.04-5.46-.68-10.9-1.51-16.35-2.28-10.88-1.62-21.74-3.37-32.59-5.19l-4.3-.72,1.68-4.29,7.85-20.03,8.02-19.96,3.03,5.03c-11.62-.69-23.23-1.44-34.84-2.33-5.8-.47-11.61-.9-17.4-1.47-5.8-.54-11.6-1.04-17.39-1.7l.13-2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m499.56,261.22c5.14,2.9,10.19,5.94,15.26,8.94,5.09,2.98,10.11,6.07,15.15,9.13,10.05,6.16,20.04,12.45,29.99,18.78l4.22,2.68-3.9,3.26-16.13,13.47-16.25,13.32.03-5.72c8.47,7.36,16.91,14.76,25.26,22.27,4.15,3.79,8.34,7.52,12.44,11.39,4.11,3.84,8.26,7.64,12.29,11.58l-1.75,2.28c-4.51-3.32-8.92-6.78-13.36-10.19-4.45-3.39-8.81-6.91-13.21-10.38-8.74-7-17.41-14.1-26.04-21.26l-3.42-2.84,3.46-2.88,16.15-13.46,16.26-13.31.31,5.94c-9.82-6.56-19.61-13.18-29.32-19.91-4.85-3.39-9.71-6.74-14.51-10.21-4.81-3.45-9.64-6.86-14.39-10.41l1.47-2.49Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1134.56,384.43c-5.78.66-11.57,1.15-17.35,1.69-5.78.57-11.57,1-17.36,1.47-11.58.89-23.16,1.64-34.75,2.33l3.02-5.01,8,19.91,7.83,19.98,1.68,4.28-4.29.72c-10.82,1.81-21.66,3.56-32.51,5.18-5.43.77-10.86,1.6-16.31,2.27-5.45.7-10.88,1.46-16.35,2.03l-.47-2.88c5.34-1.36,10.71-2.54,16.06-3.78,5.35-1.27,10.73-2.38,16.1-3.55,10.75-2.26,21.52-4.39,32.31-6.46l-2.62,5-7.98-19.92-7.81-19.99-1.89-4.84,4.91-.18c11.6-.42,23.2-.78,34.81-1,5.81-.09,11.61-.21,17.42-.2,5.81-.01,11.61-.07,17.43.03l.13,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1078.6,264.13c-4.74,3.54-9.56,6.94-14.36,10.39-4.79,3.46-9.64,6.81-14.48,10.19-9.69,6.72-19.46,13.32-29.25,19.87l.31-5.93,16.22,13.27,16.11,13.43,3.45,2.87-3.41,2.83c-8.61,7.14-17.25,14.22-25.98,21.21-4.39,3.46-8.74,6.97-13.18,10.35-4.43,3.4-8.82,6.86-13.32,10.17l-1.75-2.28c4.03-3.93,8.16-7.71,12.26-11.55,4.09-3.85,8.27-7.58,12.41-11.36,8.33-7.49,16.75-14.88,25.2-22.22l.03,5.7-16.21-13.29-16.09-13.44-3.89-3.25,4.21-2.68c9.93-6.32,19.89-12.59,29.92-18.74,5.03-3.06,10.04-6.14,15.11-9.11,5.06-2.99,10.1-6.03,15.23-8.92l1.47,2.49Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1141.11,1240.1h-628.35l65-463.33,264.17-107.92c1.97,0,39.9,6.02,85.12,13.33,111.6,18,211.67,79.32,277.97,170.85,66.2,91.4,128.6,205.85,96.47,281.3l-160.4,105.77Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m792.19,1177.58h33.62c34.76,0,62.98,28.22,62.98,62.98h-159.59c0-34.76,28.22-62.98,62.98-62.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 779.77,
    y: 1207.13,
    width: 73.37,
    height: 5,
    transform: "translate(-641.6 1271.75) rotate(-58.42)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m709.74,1094.61c-26.29,30.63-37.52,64.94-33.26,103.04,24.04-7.63,45.46-13.49,62.33-14.43,100.62-5.62,114.44,29.75,124.37,8.12,16.49-35.89-17.99-85.08-153.44-96.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m709.74,1094.61c-39.08-3.36-86.54-3.62-143.64.49l48.33-161.25,153.75-262.5-56.1,11.04c-89.25,17.56-170.09,65.79-225.75,137.74-15.4,19.91-28.91,41.43-40.24,64.33-60.78,122.83-84.97,271.34-45,317.31,65.38,75.18,187.84,23.69,275.38-4.11-4.25-38.1,6.97-72.42,33.26-103.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m525.05,1241.35c25.75-2.23,51.21-6.48,76.02-13.8,25.35-7.49,49.8-17.69,74.13-27.92,1.46-.61.82-3.03-.66-2.41-23.76,9.99-47.62,19.95-72.33,27.38-25.17,7.57-50.99,11.98-77.15,14.25-1.59.14-1.61,2.64,0,2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m562.51,1096c45.74-4.58,91.8-4.3,137.48.83,1.6.18,1.58-2.32,0-2.5-45.68-5.13-91.74-5.41-137.48-.83-1.59.16-1.6,2.66,0,2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m562.25,1092.67c12.94-73.67,41.59-144,83.82-205.73.91-1.33-1.25-2.58-2.16-1.26-42.33,61.89-71.09,132.47-84.07,206.33-.28,1.57,2.13,2.25,2.41.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m669.46,1109.81c-14.99,22.28-22.78,48.45-22.46,75.3.02,1.61,2.52,1.61,2.5,0-.32-26.44,7.35-52.1,22.12-74.04.9-1.34-1.26-2.59-2.16-1.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m853.76,1197.06l-2.43-.58,1.22.29-1.22-.26s.31-1.77-1.59-4.54c-3.73-5.43-16.68-15.76-61.58-23.97l.45-2.46c43.99,8.05,58.76,18.22,63.4,25.33,2.3,3.53,1.82,5.93,1.76,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m863.89,1188.06c-.11-.27-11.48-26.95-72.76-35.47l.34-2.48c62.92,8.75,74.29,35.88,74.74,37.03l-2.32.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m866.39,1173.91c-.03-.08-3.41-8.05-13.85-16.77-9.65-8.06-27.49-18.43-57.64-22.05l.3-2.48c59.22,7.09,72.95,38.99,73.51,40.35l-2.31.95Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "614.89 935.01 613.97 932.69 723.45 889.56 802.5 930.34 889.19 877.82 975.65 925.67 974.44 927.86 889.24 880.71 802.6 933.2 723.31 892.3 614.89 935.01"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "959.27 953.05 841.79 950.97 875.57 748.49 993.05 750.56 959.27 953.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "957.24 798.29 901.02 797.29 905.4 775.79 961.63 776.79 957.24 798.29"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m988.89,999.11s-31-55.74-46.86-65.7c-12.47-7.82-38.58-4.25-58.3-27.98-9.02-10.85-8.5-23.79-4.58-28.74,8.95-11.29,15.69-13.26,86.08-9.58,0,0-10.16-61.98,2.64-59.07,10.11,2.3,22.22,40.95,28.22,49.46,31.58,44.79,64.93,84.94,64.93,84.94l10.6,75.91-82.74-19.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1307,1136.79c-4.49,10.69-10.92,20.61-19.49,29.58-114.78,120.11-243.41,48.62-312.43-188.68,46.66-1.8,68.33-8.37,86.15-36.29l132.17,101.49c4.05-.01,68.64,55.1,113.6,93.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m975.12,977.6c22.98,64.72,48.36,130.27,87.79,186.99,10.57,15.2,22.24,29.63,35.28,42.79,1.13,1.14,2.9-.62,1.77-1.77-48.21-48.65-78.2-113.33-102.96-176.29-6.82-17.34-13.23-34.83-19.47-52.39-.53-1.51-2.95-.86-2.41.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m1062.52,945.71c31.19,25.9,62.39,51.81,93.58,77.71,1.23,1.02,3.01-.74,1.77-1.77-31.19-25.9-62.39-51.81-93.58-77.71-1.23-1.02-3.01.74-1.77,1.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m1008.45,998.46c24.01.29,47.01-9.18,63.86-26.28,1.13-1.15-.64-2.92-1.77-1.77-16.41,16.65-38.72,25.83-62.09,25.55-1.61-.02-1.61,2.48,0,2.5h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m942.14,885.61c-22.01,0-43.25-2.59-63.29-7.71l.62-2.42c22.51,5.75,46.57,8.29,71.55,7.49l.08,2.5c-3,.09-5.98.14-8.96.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m946.46,902.36c-20.95,0-46.43-4.01-70.32-11.11l.71-2.4c24.49,7.27,50.64,11.26,71.74,10.99l.03,2.5c-.72,0-1.44.01-2.16.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m941.66,919.11c-19,0-41.5-6.4-58.21-11.15l.51-2.45.18.05c17.64,5.02,41.82,11.88,61.12,10.98l.12,2.5c-1.22.06-2.46.09-3.72.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m745.26,748.15c31.18,28.32,78.5,28.56,109.98.57,1.2-1.07-.57-2.83-1.77-1.77-30.42,27.05-76.31,26.8-106.44-.57-1.19-1.08-2.96.68-1.77,1.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m1101.13,975.3c-18.97-35.2-39.18-69.86-56.67-105.83-.7-1.45-2.86-.18-2.16,1.26,17.48,35.98,37.7,70.63,56.67,105.83.76,1.42,2.92.16,2.16-1.26h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m866.97,582.6v86.32c0,34.48-27.95,62.43-62.42,62.43h-14.38c-34.48,0-62.4-27.95-62.4-62.43v-86.32h139.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m866.97,582.6v20.35l-.25.47c-31.65,72.7-94.85,74.95-138.95,3.55v-24.38h139.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m905.43,489.66c-1.63,84.82-48.39,148.11-108.07,148.11s-107.93-55.8-108.07-148.11c-.1-64.76,48.39-117.26,108.07-117.26s109.31,52.51,108.07,117.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m681.93,520.1c-13.12-37.5-27.77-132.48,10-181.25,29.37-31.88,117.5-54.38,199.37-21.88l-25.62,7.5c73.75,22.5,59.1,109.58,46.25,190l-21.25-3.75c-5.37-36.59-11.68-73.4-39.37-104.38-28.75-11.88-66.87-10-100-2.5-31.24,22.31-48.75,70-50,103.12l-19.37,13.12Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 687.76,
    cy: 515.1,
    r: 30
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 906.93,
    cy: 515.1,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m695.27,519.82c-5.42-9.37-15.77-14.65-26.55-13.38-1.58.19-1.6,2.69,0,2.5,9.93-1.17,19.38,3.47,24.39,12.14.81,1.39,2.97.13,2.16-1.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m898.29,517.5c2.78-8.13,10.06-13.93,18.62-14.77,1.59-.15,1.6-2.66,0-2.5-9.74.94-17.87,7.33-21.03,16.6-.52,1.53,1.89,2.18,2.41.66h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 767.23,
    cy: 495.47,
    rx: 9.06,
    ry: 10.57
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 823.8,
    cy: 495.47,
    rx: 9.06,
    ry: 10.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m781.21,460.48c1.16,2.93-8.79,4.98-18.66,8.1-9.89,3.13-20.21,4.13-20.93,1.03-.71-3.1,13.11-11.04,21.69-13.02,8.58-1.98,15.59-1.91,17.89,3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m808.29,463.85c-.47,3.12,9.69,2.88,20,3.7,10.34.82,20.62-.52,20.62-3.7s-15.26-7.81-24.06-7.81-15.62,1.64-16.56,7.81Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 797.55,
    cy: 517.29,
    rx: 6.25,
    ry: 21.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m826.09,556.48c-18.94-13.18-33.26-10.71-52.01,3.61-7.83,5.98-2.89,20.73,6.6,18.07.84-.24,1.72-.52,2.63-.85,15.46-5.7,25.76-7.51,36.7-2.78,2.74,1.18,5.07,1.11,7.04.35,6.82-2.66,7.03-12.83-.96-18.39Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 852.55,
    cy: 529.27,
    r: 22.08,
    transform: "translate(-144.84 418.87) rotate(-25.52)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 747.55,
    cy: 534.27,
    r: 22.08,
    transform: "translate(-154.62 360.01) rotate(-24.62)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1593.38,990.31c-10.05,0-18.22-8.17-18.22-18.22s8.17-18.22,18.22-18.22,18.22,8.17,18.22,18.22-8.17,18.22-18.22,18.22Zm0-32.7c-7.98,0-14.47,6.49-14.47,14.47s6.49,14.47,14.47,14.47,14.47-6.49,14.47-14.47-6.49-14.47-14.47-14.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m185.05,1056.98c-10.05,0-18.22-8.17-18.22-18.22s8.18-18.22,18.22-18.22,18.22,8.17,18.22,18.22-8.18,18.22-18.22,18.22Zm0-32.7c-7.98,0-14.47,6.49-14.47,14.47s6.49,14.47,14.47,14.47,14.47-6.49,14.47-14.47-6.49-14.47-14.47-14.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m573.7,108.32c-10.05,0-18.22-8.18-18.22-18.22s8.17-18.22,18.22-18.22,18.22,8.18,18.22,18.22-8.18,18.22-18.22,18.22Zm0-32.7c-7.98,0-14.47,6.49-14.47,14.47s6.49,14.47,14.47,14.47,14.47-6.49,14.47-14.47-6.49-14.47-14.47-14.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m1080.05,144.67c-10.05,0-18.22-8.18-18.22-18.22s8.17-18.22,18.22-18.22,18.22,8.18,18.22,18.22-8.17,18.22-18.22,18.22Zm0-32.7c-7.98,0-14.47,6.49-14.47,14.47s6.49,14.47,14.47,14.47,14.47-6.49,14.47-14.47-6.49-14.47-14.47-14.47Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "353.8 776 342.33 776 342.33 773.5 351.3 773.5 351.3 764.53 353.8 764.53 353.8 776"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m321.38,776h-20.94v-2.5h20.94v2.5Zm-41.89,0h-20.94v-2.5h20.94v2.5Zm-41.88,0h-20.94v-2.5h20.94v2.5Zm-41.89,0h-20.94v-2.5h20.94v2.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "153.84 776 142.37 776 142.37 764.53 144.87 764.53 144.87 773.5 153.84 773.5 153.84 776"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m144.87,742.71h-2.5v-21.81h2.5v21.81Zm0-43.63h-2.5v-21.81h2.5v21.81Zm0-43.63h-2.5v-21.81h2.5v21.81Zm0-43.63h-2.5v-21.81h2.5v21.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "144.87 568.2 142.37 568.2 142.37 556.73 153.84 556.73 153.84 559.23 144.87 559.23 144.87 568.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m321.38,559.23h-20.94v-2.5h20.94v2.5Zm-41.88,0h-20.94v-2.5h20.94v2.5Zm-41.89,0h-20.94v-2.5h20.94v2.5Zm-41.89,0h-20.94v-2.5h20.94v2.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "353.8 568.2 351.3 568.2 351.3 559.23 342.33 559.23 342.33 556.73 353.8 556.73 353.8 568.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m353.8,742.71h-2.5v-21.81h2.5v21.81Zm0-43.63h-2.5v-21.81h2.5v21.81Zm0-43.63h-2.5v-21.81h2.5v21.81Zm0-43.63h-2.5v-21.81h2.5v21.81Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    y: 467.61,
    width: 303.78,
    height: 397.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 73.14,
    y: 495.95,
    width: 157.5,
    height: 21.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.78,
    y: 551.3,
    width: 28.83,
    height: 28.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.78,
    y: 615.26,
    width: 28.83,
    height: 28.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.78,
    y: 679.21,
    width: 28.83,
    height: 28.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.78,
    y: 743.17,
    width: 28.83,
    height: 28.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.78,
    y: 807.12,
    width: 28.83,
    height: 28.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 85.64,
    y: 551.3,
    width: 192.36,
    height: 9.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 85.64,
    y: 569.03,
    width: 130.24,
    height: 9.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 85.64,
    y: 615.71,
    width: 159.98,
    height: 9.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 85.64,
    y: 633.45,
    width: 65.1,
    height: 9.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 85.64,
    y: 679.67,
    width: 192.36,
    height: 9.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 85.64,
    y: 697.4,
    width: 160.99,
    height: 9.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 85.64,
    y: 743.62,
    width: 145.78,
    height: 9.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 85.64,
    y: 761.36,
    width: 97.86,
    height: 9.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 85.64,
    y: 807.58,
    width: 174.56,
    height: 9.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 85.64,
    y: 825.31,
    width: 145.91,
    height: 9.06
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m28.89,623.96c6.41,4.96,12.82,9.93,19.24,14.89,2.72,2.1,6.57-1.69,3.82-3.82-6.41-4.96-12.82-9.93-19.24-14.89-2.72-2.1-6.57,1.69-3.82,3.82h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m33.91,639.06c5.42-5.86,11.23-11.31,17.42-16.35,2.7-2.2-1.15-6-3.82-3.82-6.19,5.04-12,10.49-17.42,16.35-2.36,2.55,1.45,6.38,3.82,3.82h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m28.89,688.51c6.41,4.96,12.82,9.93,19.24,14.89,2.72,2.1,6.57-1.69,3.82-3.82-6.41-4.96-12.82-9.93-19.24-14.89-2.72-2.1-6.57,1.69-3.82,3.82h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m33.91,703.61c5.42-5.86,11.23-11.31,17.42-16.35,2.7-2.2-1.15-6-3.82-3.82-6.19,5.04-12,10.49-17.42,16.35-2.36,2.55,1.45,6.38,3.82,3.82h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m28.89,752.47c6.41,4.96,12.82,9.93,19.24,14.89,2.72,2.1,6.57-1.69,3.82-3.82-6.41-4.96-12.82-9.93-19.24-14.89-2.72-2.1-6.57,1.69-3.82,3.82h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m33.91,767.57c5.42-5.86,11.23-11.31,17.42-16.35,2.7-2.2-1.15-6-3.82-3.82-6.19,5.04-12,10.49-17.42,16.35-2.36,2.55,1.45,6.38,3.82,3.82h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m28.89,817.42c6.41,4.96,12.82,9.93,19.24,14.89,2.72,2.1,6.57-1.69,3.82-3.82-6.41-4.96-12.82-9.93-19.24-14.89-2.72-2.1-6.57,1.69-3.82,3.82h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m33.91,832.53c5.42-5.86,11.23-11.31,17.42-16.35,2.7-2.2-1.15-6-3.82-3.82-6.19,5.04-12,10.49-17.42,16.35-2.36,2.55,1.45,6.38,3.82,3.82h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m28.89,561.09c6.41,4.96,12.82,9.93,19.24,14.89,2.72,2.1,6.57-1.69,3.82-3.82-6.41-4.96-12.82-9.93-19.24-14.89-2.72-2.1-6.57,1.69-3.82,3.82h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m33.91,576.19c5.42-5.86,11.23-11.31,17.42-16.35,2.7-2.2-1.15-6-3.82-3.82-6.19,5.04-12,10.49-17.42,16.35-2.36,2.55,1.45,6.38,3.82,3.82h0Z"
  })))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 941.1,
    y: 1210.98,
    width: 160,
    height: 29.52
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1310.98 1240.53 1012.87 1240.53 1139.44 961.77 1437.55 961.77 1310.98 1240.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m1238.08,1121.99h-44.68l18.92-41.68h44.68l-18.92,41.68Zm-38.86-3.75h36.44l15.52-34.18h-36.44l-15.52,34.18Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 251.55,
    y: 1238.62,
    width: 1214.94,
    height: 3.75
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAssigned);
export default __webpack_public_path__ + "static/media/NotAssigned.c439ec1cf3e4b4c311572c83ac2cc029.svg";
export { ForwardRef as ReactComponent };